import {
  ACTION_SET_TRADES_WALLET,
  ACTION_SET_DRAW_MARKS,
  ACTION_SET_REMOVE_MARKS,
} from '../actions/dex_trades';

export interface IDexTradesState {
  pair: string | null;
  tradesWallet: string | null;
  drawMarks: (() => void) | null;
  removeMarks: (() => void) | null;
}

const defaultState: IDexTradesState = {
  pair: null,
  tradesWallet: null,
  drawMarks: null,
  removeMarks: null,
};

const dexTrades = (
  state: IDexTradesState = defaultState,
  action: any
): IDexTradesState => {
  switch (action.type) {
  case ACTION_SET_TRADES_WALLET:
    return {
      ...state,
      tradesWallet: action.payload,
    };
  case ACTION_SET_DRAW_MARKS:
    return {
      ...state,
      drawMarks: action.payload,
    };
  case ACTION_SET_REMOVE_MARKS:
    return {
      ...state,
      removeMarks: action.payload,
    };
  default:
    return state;
  }
};

export default dexTrades;
